
import Vue from 'vue';
import DebouncedInput from '@/components/base/DebouncedInput.vue';
import FilterToggleButton from '@/components/Filters/FilterToggleButton.vue';
import RefreshListButton from '@/components/Filters/RefreshListButton.vue';

/**
 * The row above every list table: the search on the left, and on the right a
 * Refresh button, the Filter button that opens the table's <filters-panel>, then
 * anything that changes how the list shows (Boards' grid/table switch) in the
 * `actions` slot. A button that adds to the list (New Team, Add Members, Assign
 * Company Role) sits in the page's header instead, beside its title. One
 * component so the Directory, a Team's members, a member's Teams, the company's
 * Teams and Boards all look and behave alike.
 *
 * It decides nothing: the host owns the search text, whether the box is open
 * and what is applied, and hears `search` and `toggle-filters`. A host that
 * listens for `refresh` gets the Refresh button, and passes `refreshing` while
 * its list loads.
 */
export default Vue.extend({
	name: 'TableToolbar',
	props: {
		searchValue: { type: String, default: '' },
		searchPlaceholder: { type: String, default: 'Search...' },
		filtersExpanded: { type: Boolean, default: false },
		// How many filters are applied, for the Filter button's count.
		appliedFilterCount: { type: Number, default: 0 },
		// A table with nothing to filter by (personal Boards) shows only its search.
		showFilterButton: { type: Boolean, default: true },
		// The list is loading, so the Refresh button spins and ignores clicks.
		refreshing: { type: Boolean, default: false },
	},
	components: {
		DebouncedInput,
		FilterToggleButton,
		RefreshListButton,
	},
});
